import { create } from 'zustand';

/**
 * 공통 레이아웃 골격 셸 상태 — 설계 §4.3.
 * docs/design/design-20260717-common-layout-skeleton.md
 *
 * 소유 범위(SSOT 중복 금지):
 *   - ① 좌측 레일 접힘/펼침은 본 store 가 소유하지 않는다 → 기존 `sidebarStore`(collapsed) 재사용.
 *   - 본 store 는 (가)메뉴설명패널 · ④문서패널 · ⑤우측레일 세 축만 소유.
 *
 * ② 2차 상세에는 dock 상태축이 없다(1a/1b 모두 인라인 고정). 오버레이/인라인 도킹 축의 대상은
 * (가)메뉴 설명 패널과 ④문서 패널뿐이다.
 *
 * 라우트 전환 시 패널 축을 닫아 타 화면 자동 열림을 막는다(`resetPanelsForRouteChange`).
 * rightRail 표시 여부는 사용자 선호이므로 라우트 전환에도 유지.
 */
export type PanelDock = 'closed' | 'inline' | 'overlay';
export type DocPanelDock = 'closed' | 'inline' | 'overlay' | 'expanded';

interface LayoutShellState {
  /** (가) 메뉴 설명 패널 — 1a(overlay)/1b(inline). */
  menuDescPanel: PanelDock;
  /** ④ 우측 상세 문서 패널. */
  docPanel: DocPanelDock;
  /** ⑤ 우측 사이드 레일 표시. */
  rightRail: 'shown' | 'hidden';

  setMenuDescPanel: (state: PanelDock) => void;
  setDocPanel: (state: DocPanelDock) => void;
  setRightRail: (state: 'shown' | 'hidden') => void;
  toggleRightRail: () => void;
  /** 라우트 전환 시 호출 — 패널 축만 닫고 rightRail 표시는 유지(§4.3). */
  resetPanelsForRouteChange: () => void;
}

export const useLayoutShellStore = create<LayoutShellState>((set) => ({
  menuDescPanel: 'closed',
  docPanel: 'closed',
  rightRail: 'shown',

  setMenuDescPanel: (menuDescPanel) => set({ menuDescPanel }),
  setDocPanel: (docPanel) => set({ docPanel }),
  setRightRail: (rightRail) => set({ rightRail }),
  toggleRightRail: () => set((s) => ({ rightRail: s.rightRail === 'shown' ? 'hidden' : 'shown' })),
  resetPanelsForRouteChange: () => set({ menuDescPanel: 'closed', docPanel: 'closed' }),
}));
